'use client';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Size = 'small' | 'medium' | 'large';

const sizeMap: Record<Size, { wrap: string; logo: string; size: string }> = {
  small: {
    wrap: '32px',
    logo: '18px',
    size: 'xs',
  },
  medium: {
    wrap: '48px',
    logo: '32px',
    size: 'sm',
  },
  large: {
    wrap: '60px',
    logo: '32px',
    size: 'sm',
  },
};

export function Loading({
  children,
  className,
  size = 'large',
  showText = true,
}: {
  children?: ReactNode;
  className?: string;
  size?: Size;
  showText?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className={`co-loading text-center ${className}`}>
      <div className={`co-loading-main`} style={{ height: sizeMap[size].wrap, width: sizeMap[size].wrap }}>
        <div className={`co-loading-animation ${sizeMap[size].size}`}></div>
        <div className="co-loading-logo" style={{ height: sizeMap[size].logo, width: sizeMap[size].logo }}></div>
      </div>
      {showText && <span className={`text-${sizeMap[size].size} mt-4 text-base`}>{children || `${t('action.loading')} ...`}</span>}
    </div>
  );
}
